module.exports = __webpack_public_path__ + "static/media/i-am-2.a32b96c5.jpeg";